import { useNavigate } from "react-router-dom";
import React from 'react';
import { Helmet } from "react-helmet";  

export const seo = {
    title: "Terms & Conditions | Aooz Status",
    description: "Read the Terms and Conditions for using Aooz Status. Learn about user responsibilities, content usage, and platform policies for status.aooz.in.",
    keywords: "aooz status terms, aooz terms and conditions, status aooz policy, aooz status rules, status sharing platform terms",
    url: "https://status.aooz.in/terms-and-conditions",
    image: "https://status.aooz.in/logo.png"
};

export default function Terms_and_conditions() {

    const navigate = useNavigate();

    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size_info">

                    <h2 className="text-xl font-bold mb-4">Terms & Conditions</h2>
       <div className='text-h2'>
                            Welcome to <strong>Aooz Status</strong> (status.aooz.in). By accessing or using this website,
                            you agree to comply with and be bound by the following Terms and Conditions.
                            If you do not agree with any part of these terms, please do not use our website.
                        </div>
<br/><br/>
                    <div className='ui-grid'>

                
                     
                       <div className='ui-items'>
                           <h4>1. Use of the Website</h4>
                            Aooz Status provides users with a collection of status messages, quotes,
                            and social media content for personal use and sharing. You agree to use
                            this website only for lawful purposes and in accordance with these terms.
                        </div>

               
                       <div className='ui-items'>
                                 <h4>2. Content Usage</h4>
                            The status messages, quotes, and text available on this platform are provided
                            for informational and entertainment purposes. Users may copy or share the
                            content for personal use on social media platforms.
                        </div>

                       <div className='ui-items'>
                            You may not reproduce, distribute, or commercially exploit any content from
                            this website without proper permission.
                        </div>

             
                       <div className='ui-items'>
                                   <h4>3. User Responsibility</h4>
                            Users are responsible for how they use or share content from this website.
                            Aooz Status is not responsible for any misuse, misinterpretation, or
                            consequences arising from the use of our content.
                        </div>

                   
                       <div className='ui-items'>
                             <h4>4. Intellectual Property</h4>
                            All design, layout, branding, and platform functionality belong to
                            Aooz Status. Unauthorized copying of the website design or platform
                            features is strictly prohibited.
                        </div>

                 
                       <div className='ui-items'>
                               <h4>5. Third-Party Links</h4>
                            Our website may include links to external websites or social media platforms.
                            We are not responsible for the content, policies, or practices of these
                            third-party websites.
                        </div>

               
                       <div className='ui-items'>
                                 <h4>6. Limitation of Liability</h4>
                            Aooz Status will not be liable for any direct, indirect, or incidental
                            damages resulting from the use or inability to use our website.
                        </div>

                   
                       <div className='ui-items'>
                             <h4>7. Changes to Terms</h4>
                            We reserve the right to update or modify these Terms and Conditions
                            at any time without prior notice. Continued use of the website
                            after changes means you accept the updated terms.
                        </div>

                    
                       <div className='ui-items'>
                            <h4>8. Contact</h4>
                            If you have any questions regarding these Terms and Conditions,
                            please contact us through our support page.
                        </div>

                       <div className='ui-items'>
                            <strong>Last Updated:</strong> 2026
                        </div>

                    </div>

                </div>
            </div>

        </div>
    );
}